export const CATEGORIES = [
  { label: "Sports Nutrition", to: "/product/multi/nutrients" },
  { label: "Vitamins & Supplements", to: "/product/multi/vitamins" },
  { label: "Ayurveda & Herbs", to: "/product/multi/ayurveda" },
  { label: "Health Food & Drinks", to: "/product/multi/food" },
];
